import {ProductBrowser} from "../../ecwid/product-browser"

const Store = ({global, metadata }) => {

    return (
        <div className="py-12" key="_storepage" id="_storepage">
            {/* <ProductBrowser storeId="100774270" key="_storefront" id="_storefront"/> */}
        </div>
    )
}

export default Store